import { IsUrlExtendedSwitch } from 'features/IsUrlExtendedSwitch'
import { FC } from 'react'
import { RenderIf } from 'shared/helpers/renderIf'
import { withHeaderHOC } from 'shared/HOCs/withHeaderHOC'
import { withSideBarHOC } from 'shared/HOCs/withSidebarHOCs'
import { useGlobalStore } from 'shared/store/globalSlice'
import { QRCodeAccordion } from 'widgets/_Accordions/QRCode'
import { TableDisplayAccordion } from 'widgets/_Accordions/TableDisplay'

export const QRCodeComponent: FC = () => {
  const isCC = useGlobalStore().isCCSelected

  return (
    <>
      <RenderIf condition={!isCC}>
        <IsUrlExtendedSwitch />
      </RenderIf>
      <QRCodeAccordion />
      <TableDisplayAccordion />
    </>
  )
}

// TODO: translations
export const QRCode = withSideBarHOC(withHeaderHOC(QRCodeComponent, 'QR-Code'))
